/**
 * @file store getters
 * @author zhangzhimeng
 */

export default {
  columnTreeList (state) {
    return state.columnTreeList
  },
  footerList (state) {
    return state.footerList
  },
  user (state) {
    var user = state.user
    if (sessionStorage.getItem('user')) {
      user = JSON.parse(sessionStorage.getItem('user'))
    }
    return user
  },
  websit (state) {
    return state.websit
  },
  tenant (state) {
    var tenant = state.tenant
    if (sessionStorage.getItem('tenant')) {
      tenant = JSON.parse(sessionStorage.getItem('tenant'))
    }
    return tenant
  },
  isLogin (state) {
    return !!state.user
  },
  activeIndex: state => {
    return state.activeIndex
  },
  columnItem: state => {
    return state.columnItem
  },
  columnItemParent: state => {
    return state.columnItemParent
  },
  activeChildrenIndex: state => {
    return state.activeChildrenIndex
  },
  contentId: state => {
    return state.contentId
  },
  token (state) {
    return state.token || ''
  },
  websitBanner (state) {
    return state.websitBanner || ''
  },
  websitLogo (state) {
    return state.websitLogo || ''
  },
  // 主办单位
  siteIntro (state) {
    return state.siteIntro || ''
  },
  siteAddress (state) {
    return state.siteAddress || ''
  },
  specialInfo (state) {
    return state.specialInfo
  },
  caseTypeList (state) {
    return state.caseTypeList
  },
  workTypeList (state) {
    return state.workTypeList
  },
  specificTypeList (state) {
    return state.specificTypeList
  }

}



// WEBPACK FOOTER //
// ./src/store/getters.js